/**
 * Opt-in debug logging for widget chat transport + message buffer, and
 * merged `conf.orderStatus` (see `normalizeConfig.js`).
 *
 * Debug is ON when any of these is true (first match wins):
 *   1. `import.meta.env.VITE_CHAT_DEBUG === 'true'` (set in `.env`, rebuild widget)
 *   2. Vite dev server: `import.meta.env.DEV === true` (no rebuild — `npm run dev`)
 *   3. `localStorage.getItem('ometricsAiChatDebug') === '1'`
 *   4. `sessionStorage.getItem('ometricsAiChatDebug') === '1'`
 *   5. Page URL has `?chatDebug=1` or `?ometricsAiChatDebug=1` (works with production bundle)
 *   6. `window.__OMETRICS_AI_CHAT_DEBUG__ = true` before the widget script runs
 *
 * Turn off URL-based debug: remove query param and reload.
 * Turn off storage: `localStorage.removeItem('ometricsAiChatDebug')` etc.
 */
export function isWidgetChatDebugEnabled() {
  try {
    if (import.meta.env?.VITE_CHAT_DEBUG === 'true') {
      return true
    }
    if (import.meta.env?.DEV === true) {
      return true
    }
    if (
      typeof localStorage !== 'undefined' &&
      localStorage.getItem('ometricsAiChatDebug') === '1'
    ) {
      return true
    }
    if (
      typeof sessionStorage !== 'undefined' &&
      sessionStorage.getItem('ometricsAiChatDebug') === '1'
    ) {
      return true
    }
    if (typeof window !== 'undefined' && window.__OMETRICS_AI_CHAT_DEBUG__ === true) {
      return true
    }
    if (typeof window !== 'undefined' && debugFromUrl()) {
      return true
    }
  } catch {
    // ignore
  }
  return false
}

function debugFromUrl() {
  try {
    const q = new URLSearchParams(window.location.search)
    if (q.get('chatDebug') === '1' || q.get('ometricsAiChatDebug') === '1') {
      return true
    }
    const raw = window.location.hash.replace(/^#/, '')
    if (raw && new URLSearchParams(raw).get('chatDebug') === '1') {
      return true
    }
  } catch {
    // ignore
  }
  return false
}

export function widgetChatDebug(...args) {
  if (!isWidgetChatDebugEnabled()) {
    return
  }
  console.info('[OmetricsAI Chat]', ...args)
}
